//eslint-disable
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { ArcaHttpWalkplan } from '../../../code/ArcaHttpWalkplan';
import { MapPopup } from '../Mapping/MapPopup';
import { StatusBar } from '../StatusBar';
import { Phone } from '../ReactIcons/Phone';
import { ArcaLink } from '../Fields/ArcaLink';
import { FaAddressBook } from 'react-icons/fa';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { MdEmail } from 'react-icons/md';

export class WalkerSummaryPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            today: new ArcaDate(new Date()),
            referenceDate: new ArcaDate(new Date()),
            weekPlan: null,
            statusText: null,
            isError: false,
            LoadingText: 'Panel is loading...',
            mapPetName: null,
            mapPopupOpen: false
        };
    }

    sendEmailSummary(date, walkerId) {
        ArcaHttpWalkplan.EmailWalkerCalendarAsync(walkerId,
            date,
            (() => this.setState({
                statusText: 'Email sent successfully',
                isError: false
            })),
            (err => this.setState({
                statusText: err,
                isError: true
            }))
        );
    }

    componentDidMount() {
        ArcaHttpWalkplan.GetWalkerCalendarAsync(this.props.walkerId,
            this.state.today,
            (plan => this.setState({ weekPlan: plan })).bind(this),
            (status => {
                if (status === 404)
                    this.setState({
                        statusText: 'No bookings found',
                        LoadingText: null,
                        isError: false
                    })
                else
                    this.setState({
                        statusText: 'Error retrieving plans',
                        LoadingText: null,
                        isError: true
                    })
            }).bind(this)
        );
    }

    gotPlan(plan) {
        this.setState({ weekPlan: plan });
    }

    render() {
        let lastDate = null
        let latestGroup = 1
        let { walkerId } = this.props
        let { isError, statusText, today, LoadingText, mapPopupOpen, mapPetName, postcode } = this.state

        return (
            <div>
                <h1>Your plan for the next 7 days</h1>
                <p>This list can change, so please check before you leave home</p>

                <StatusBar isError={isError} message={statusText} />
                {this.state.weekPlan
                    ? <Table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Session</th>
                                <th>Activity</th>
                                <th>Postcode</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.weekPlan.map((slot, key) =>
                                <Fragment key={key}>

                                    <tr
                                        style={slot.Date.IsSameDate(this.state.today)
                                            ? { background: '$colour-primary' }
                                            : { background: '$colour-secondary' }}>

                                        {lastDate !== slot.Date.DayAndMonthPretty && (lastDate = slot.Date.DayAndMonthPretty)
                                            ? <td colSpan='5' >
                                                {(latestGroup === 0) ? null : null}

                                                <h5>  <ArcaLink
                                                    colour={slot.Date.IsSameDate(this.state.today) ? '$colour-secondary' : '$colour-primary'}
                                                    icon={<MdEmail height='35px' width='160px' color={slot.Date.IsSameDate(this.state.today) ? '$colour-primary' : '$colour-secondary'} />}
                                                    text='Email'
                                                    onClick={this.sendEmailSummary.bind(this, slot.Date, walkerId)}
                                                />
                                                    {'   ' + slot.Date.DayAndMonthPretty} {slot.Date.IsSameDate(this.state.today) ? ' - Today' : null}
                                                </h5>

                                            </td>
                                            : null}
                                    </tr>

                                    {latestGroup !== slot.GroupId
                                        ? <tr style={{ background: '#DDD' }}>
                                            <td colSpan='5'>
                                                <h5>{'Days walk ' + (latestGroup = latestGroup + 1)}</h5>
                                            </td>
                                        </tr>
                                        : null}

                                    <tr style={slot.Date.IsSameDate(today)
                                        ? { background: '#F2C287' }
                                        : null}>

                                        <td>{slot.Name}</td>
                                        {/*<td><Link to={"/PersonView?id=" + slot.OwnerId}>{slot.Name}</Link></td>
                                        <td><Phone phone={slot.OwnerTelephone} text={ArcaHttpSystem.IsSmartphone ? '' : slot.OwnerTelephone} /></td>*/}
                                        <td>{slot.Session}</td>
                                        <td>{slot.ActivityType}</td>
                                        {slot.Postcode.length > 5
                                            ? <td><ArcaLink text={slot.Postcode} width='150px' onClick={this.showMap.bind(this, slot.Postcode, slot.Name)} icon={<FaAddressBook />} /> </td>
                                            : <td>{slot.Postcode} </td>}

                                    </tr>
                                </Fragment>
                            )}
                        </tbody>
                    </Table>
                    : <h6>{LoadingText}</h6>}

                {mapPopupOpen
                    ? <MapPopup
                        titleText={mapPetName + "lives here!"}
                        postcode={postcode}
                        onClose={(() => this.setState({ mapPopupOpen: false })).bind(this)} />
                    : null}
            </div>
        );
    }

    showMap(postcode, petName) {
        this.setState({
            mapPetName: petName,
            postcode: postcode,
            mapPopupOpen: true
        });
    }
}